

exports.__esModule = true;
exports.$miniBrowser = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _uiRouter = require('uiRouter');

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _squid = require('squid');

var _checkout = require('xo-models/src/checkout');

var _util = require('xo-return-to-merchant/dist/util');

var _integration = require('./integration');

var _error = require('./error');

var _$stateGo = _uiRouter.$state.go;

var logStateNotFoundAndThrow = function logStateNotFoundAndThrow(_ref) {
    var name = _ref.name,
        _ref$logName = _ref.logName,
        logName = _ref$logName === undefined ? '' : _ref$logName;

    _logger.$logger.error('state_not_found' + logName, {
        name: name,
        hash: window.location.hash
    });
    throw new Error('state_not_found' + logName + ': ' + name);
};

_uiRouter.$state.go = function (name, params) {
    var _this = this,
        _arguments = arguments;

    var stateObj = _uiRouter.$state.get(name);

    var stateGo = function stateGo(state) {
        if (!window.xchild) {
            return _$stateGo.apply(_this, _arguments);
        }

        if (!state.loginRequired) {
            return _$stateGo.apply(_this, _arguments);
        }

        // If we're allowed to collect data in this integration, we don't need this functionality
        if (_integration.$integration.getConfig('ALLOW_COLLECT_DATA')) {
            return _$stateGo.apply(_this, _arguments);
        }

        var forceIframe = window.paypal && window.paypal.forceIframe && window.paypal.forceIframe();

        if (forceIframe) {
            return _$stateGo.apply(_this, _arguments);
        }

        // First check our integration supports falling back to a popup
        if (!_integration.$integration.getConfig('CAN_FALLBACK_TO_POPUP')) {
            throw _integration.$integration.error('Can not fallback to popup for data collection');
        }

        window.xchild.hide();

        var url = window.location.href.split('#')[0] + '#/' + state.name.replace(/\./g, '/');
        var xprops = _extends({}, window.xprops);

        xprops.url = url;

        window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops)['catch'](function (err) {

            if (window.ppxo.PopupOpenError && err instanceof window.ppxo.PopupOpenError) {
                window.xchild.show();

                _logger.$logger.warn('framebust_from_' + name.replace(/[^a-zA-Z0-9]+/g, '_'));

                return _$stateGo.call(_this, 'checkout.framebust', { action: 'open', url: url });
            }

            (0, _error.$exceptionHandler)(err);
        });
    };

    if (stateObj) {
        return stateGo(stateObj);
    } else if (_squid.$meta.codeSplitting) {
        // in case of code split - attempt to load route and then change the state
        return (0, _squid.lazyLoadRoute)(name, params, false)['catch'](function () {
            logStateNotFoundAndThrow({ name: name, logName: '_lazy_loading' });
        }).then(function () {
            stateObj = _uiRouter.$state.get(name);
            return stateGo(stateObj);
        });
    } else {
        logStateNotFoundAndThrow({ name: name });
    }
};

var $miniBrowser = exports.$miniBrowser = {
    flags: {},
    config: {},
    isMiniBrowser: function isMiniBrowser() {
        return window.name && window.name.indexOf('PPFrame') === 0 && _squid.$util.isPopup() || _squid.$util.param('incontext') === '1' || window.xchild && _squid.$util.isPopup();
    },
    isFramed: function isFramed() {
        return _squid.$util.isIFrame();
    },
    getPartnerIntegration: function getPartnerIntegration(token) {
        return _squid.$promise.call(function () {
            if (window.name === 'PPFrameRedirect' || _squid.$util.param('nolegacy') === '1') {
                return true;
            }
            return _checkout.$CheckoutCartModel.instance(token).retrieve().then(function (cart) {
                return Boolean(cart.partnerIntegration);
            });
        });
    },
    getNativeCheckoutIntegration: function getNativeCheckoutIntegration(token) {
        return _squid.$promise.call(function () {
            if (_squid.$util.param('native_xo') === '1') {
                return true;
            }
            return false;
        });
    },
    getMessengerBAIntegration: function getMessengerBAIntegration(token) {
        return _squid.$promise.call(function () {
            if (window.xprops && window.xprops.experience && window.xprops.experience.messenger) {
                _logger.$logger.info('getMessengerBAIntegration == true');
                return true;
            }
            return false;
        });
    },
    getDirectIntegration: function getDirectIntegration(token) {
        return _squid.$promise.call(function () {
            if (_squid.$util.param('incontext')) {
                return true;
            }

            if (this.isMiniBrowser() || this.isFramed()) {
                return true;
            }

            if (window.location.pathname.indexOf('/checkoutnow') > -1 || window.location.pathname.indexOf('/webapps/hermes') > -1) {
                return true;
            }

            return this.getPartnerIntegration(token);
        }.bind(this));
    },
    getWPSIntegration: function getWPSIntegration(token) {
        return _checkout.$CheckoutAppDataModel.instance(token).retrieve().then(function (appData) {
            var isWPS = appData.is_wps_flow();

            // TODO: remove these, we should not use $rootScope
            _angular.$rootScope.invoice = appData.flags.is_invoice_flow;
            _angular.$rootScope.wps = isWPS;

            if (isWPS) {
                _logger.$logger.info('hermes_wps_flow', {
                    token: _angular.$rootScope.token
                });
            } else {
                _logger.$logger.info('hermes_xo_order_flow', {
                    token: _angular.$rootScope.token
                });
            }
            return isWPS;
        });
    },

    getWpsSubscriptionIntegration: function getWpsSubscriptionIntegration(token) {
        return _checkout.$CheckoutAppDataModel.instance(token).retrieve().then(function (appData) {
            return appData.is_wps_subscription_flow();
        });
    },

    getWpsAutobillingIntegration: function getWpsAutobillingIntegration(token) {
        return _checkout.$CheckoutAppDataModel.instance(token).retrieve().then(function (appData) {
            return appData.isWpsAutobillingFlow();
        });
    },

    getWpsInstallmentPlanIntegration: function getWpsInstallmentPlanIntegration(token) {
        return _checkout.$CheckoutAppDataModel.instance(token).retrieve().then(function (appData) {
            return appData.is_wps_installmentplan_flow();
        });
    },

    getFlags: function getFlags(token) {
        _logger.$logger.info('miniBrowser_getFlags');
        return _squid.$promise.hash({
            isMiniBrowser: this.isMiniBrowser(),
            isFramed: this.isFramed(),
            isPartnerIntegration: this.getPartnerIntegration(token),
            isDirectIntegration: this.getDirectIntegration(token),
            isNativeCheckout: this.getNativeCheckoutIntegration(token),
            isMessengerBAIntegration: this.getMessengerBAIntegration(token),
            isWPSIntegration: this.getWPSIntegration(token),
            isWpsSubscription: this.getWpsSubscriptionIntegration(token),
            isWpsAutobilling: this.getWpsAutobillingIntegration(token),
            isWpsInstallmentPlan: this.getWpsInstallmentPlanIntegration(token)
        }).then(function (flags) {

            // TODO: Remove these, we should not use $rootScope
            _angular.$rootScope.miniBrowser = flags.isMiniBrowser;
            _angular.$rootScope.partnerIntegration = flags.isPartnerIntegration;

            if (flags.isPartnerIntegration && !window.xchild) {
                _integration.$integration.setFlow(_integration.$FLOWS.PARTNER);
            } else if (flags.isFramed) {
                _integration.$integration.setFlow(_integration.$FLOWS.INCONTEXT_LIGHTBOX);
                if (flags.isMessengerBAIntegration) {
                    _integration.$integration.setFlow(_integration.$FLOWS.MESSENGER_BA_INTEGRATION);
                    _logger.$logger.info('$integration.setFlow($FLOWS.MESSENGER_BA_INTEGRATION)');
                }
            } else if (flags.isMiniBrowser) {
                _integration.$integration.setFlow(_integration.$FLOWS.INCONTEXT_POPUP);
            } else if (flags.isNativeCheckout) {
                _integration.$integration.setFlow(_integration.$FLOWS.NATIVE_CHECKOUT);
            } else if (flags.isWpsSubscription) {
                _integration.$integration.setFlow(_integration.$FLOWS.WPS_SUBSCRIPTION);
            } else if (flags.isWpsAutobilling) {
                _integration.$integration.setFlow(_integration.$FLOWS.WPS_AUTOBILLING);
            } else if (flags.isWpsInstallmentPlan) {
                _integration.$integration.setFlow(_integration.$FLOWS.WPS_INSTALLMENTPLAN);
            } else if (flags.isWPSIntegration) {
                _integration.$integration.setFlow(_integration.$FLOWS.WPS);
            } else {
                _integration.$integration.setFlow(_integration.$FLOWS.CHECKOUT);
            }

            return flags;
        });
    },
    init: function init(token) {
        var _this2 = this;

        _logger.$logger.info('miniBrowser_init');
        return _squid.$promise.sequential([function () {
            return _this2.enableAutoResize();
        }, function () {
            return _this2.getFlags(token);
        }, function () {
            return _this2.logIntegration(token);
        }, function () {
            return _this2.sendPostMessage(token);
        }, function () {
            return _this2.handleWindowOpenerClose();
        }]);
    },
    enableAutoResize: function enableAutoResize() {
        _angular.$rootScope.$on('allLoaded', function () {
            if (window.xchild && window.xchild.enableAutoResize) {
                window.xchild.enableAutoResize();
            }
        });
    },
    logIntegration: function logIntegration(token) {
        _logger.$logger.info('miniBrowser_logIntegration');
        return this.getFlags(token).then(function (flags) {
            var match = window.name.match(/PPFrame(\w+)/);
            var guid = match && match[1];

            if (guid) {
                _logger.$logger.info('integration_guid', {
                    guid: guid
                });
            }

            if (window.xchild || guid) {
                var beacon = new Image();

                beacon.src = '/webapps/hermes/api/logger?event=ppxo_uid_token&uid=' + (window.xprops ? window.xprops.uid : guid) + '&token=' + token;
            }

            _logger.$logger.info(flags.isMiniBrowser ? 'minibrowser_flow' : 'non_minibrowser_flow');
            _logger.$logger.info(flags.isFramed ? 'framed_flow' : 'non_framed_flow');
            _logger.$logger.info(flags.isDirectIntegration ? 'direct_integration_flow' : 'non_direct_integration_flow');
            _logger.$logger.info(flags.isPartnerIntegration ? 'partner_integration_flow' : 'non_partner_integration_flow');
        });
    },

    handleWindowOpenerClose: function handleWindowOpenerClose() {
        _logger.$logger.info('miniBrowser_handleWindowOpenerClose');
        if (_integration.$integration.isContext(_integration.$CONTEXT.POPUP)) {
            var interval = setInterval(function () {
                try {
                    if (!window.opener || window.opener.closed) {
                        clearInterval(interval);
                        _logger.$logger.info('window_opener_closed');
                        // TODO: close this window if opener closed?
                    }
                } catch (err) {
                    // pass
                }
            }, 50);
        }
    },

    sendPostMessage: function sendPostMessage(token) {
        if (window.xchild) {
            return;
        }

        return _squid.$promise.hash({
            isPartnerIntegration: this.getPartnerIntegration(token),
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance(token).retrieve()
        }).then(function (data) {
            if (!_integration.$integration.getConfig('POST_MESSAGE_PARENT')) {
                return;
            }

            var msg = void 0;

            try {
                msg = {
                    operation: 'init',
                    cancelUrl: data.checkoutAppData.urls.cancel_url,
                    landingUrl: window.location.href,
                    secureWindowmsg: _squid.$locale.content.scripts.secureWindowmsg
                };
            } catch (err) {
                return _logger.$logger.error('minibrowser_msg_construction_failed', {
                    error: err
                });
            }

            if (!_util.$ReturnToMerchant.postToMerchant(msg)) {
                _logger.$logger.error('minibrowser_post_failed');
            }
        });
    },
    frameBust: function frameBust(token) {
        return _squid.$promise.hash({
            isFramed: this.isFramed()
        }).then(function (flags) {
            if (!flags.isFramed) {
                return;
            }

            var forceIframe = window.paypal && window.paypal.forceIframe && window.paypal.forceIframe();

            if (forceIframe) {
                return;
            }

            if (window.xchild) {
                _logger.$logger.info('frame_bust_xchild');
                _uiRouter.$state.go('checkout.framebust', { action: 'open', url: window.location.href.split('#')[0] });
            } else {
                _logger.$logger.info('frame_bust');
                _squid.$util.redirect(window.location.href, { frameBust: true });
            }
        });
    }
};

angular.value("$miniBrowser", $miniBrowser);
_uiRouter.$state;

_angular.$rootScope;

_logger.$logger;

_squid.$promise;

_squid.$util;

_squid.$locale;

_squid.$meta;

_squid.lazyLoadRoute;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_util.$ReturnToMerchant;

_integration.$integration;

_integration.$FLOWS;

_integration.$CONTEXT;

_error.$exceptionHandler;


//////////////////
// WEBPACK FOOTER
// ./js/lib/miniBrowser.js
// module id = ./js/lib/miniBrowser.js
// module chunks = main-code-split